import CardNumber from 'components/CardNumber'
import Top from 'components/Top'

import {
  RiPinDistanceFill
} from 'react-icons/ri'

const Distance = () => {

  return <div className="scroll one hs in-air-2x gap-2x">
    <div className="vs gap-2x size-2x8">
      <h2 className="one">distance</h2>

      <span><RiPinDistanceFill /></span>
    </div>

    <div className="vs gap-2x">

      <CardNumber
        { ...{
          url: '/statistics/byDistance/total',
          title: 'total',
          units: 'km',
          ceil: true
        } }
      />

      <CardNumber
        { ...{
          url: '/statistics/byDistance/avg',
          title: 'avg',
          units: 'km',
          ceil: true
        } }
      />

    </div>

    <div className="vs gap-2x">

      <CardNumber
        { ...{
          url: '/statistics/byDistance/max',
          title: 'max',
          units: 'km',
          ceil: true
        } }
      />

      <CardNumber
        { ...{
          url: '/statistics/byDistance/min',
          title: 'min',
          units: 'km',
          ceil: true
        } }
      />

    </div>

    <Top
      { ...{
        url: '/statistics/byDistance/top',
        units: 'km'
      } }
    />

  </div>

}

export default Distance
